<template>
  <div v-loading="pageLoading">
    <el-form class="full-width mb-2px" :model="filterForm">
      <div class="filter-bar" type="flex">
        <el-form-item class="mb-none" label="学年">
          <school-year-selector
            v-model="filterForm.schoolYear"
            @change="onYearTermChange"
          ></school-year-selector>
        </el-form-item>
        <el-form-item class="mb-none" label="学期">
          <school-term-selector
            v-model="filterForm.schoolTerm"
            :checkAll="false"
            @change="onYearTermChange"
          ></school-term-selector>
        </el-form-item>
        <el-form-item class="mb-none" label="模块">
          <el-select
            size="small"
            v-model="filterForm.moduleKeyword"
            clearable
            placeholder="全部"
            style="width: 120px"
            @change="refresh"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in moduleOptions"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="teacherOptions.length" class="mb-none" label="申请人">
          <el-select
            size="small"
            v-model="filterForm.teacherId"
            clearable
            filterable
            placeholder="请选择申请人"
            style="width: 130px"
            @change="refresh"
          >
            <el-option
              v-for="item in teacherOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="mb-none" label="教研组">
          <el-select
            size="small"
            v-model="filterForm.groupCode"
            clearable
            filterable
            placeholder="请选择教研组"
            style="width: 130px"
            :loading="groupLoading"
            @change="onGroupChange"
          >
            <el-option
              v-for="item in groupOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <div class="space"></div>
        <el-button
          v-if="teacherOptions.length"
          size="small"
          type="primary"
          :disabled="selection.length === 0"
          :loading="downloadLoading"
          @click="onBatchDownload"
          >批量下载</el-button
        >
        <el-button size="small" type="primary" icon="el-icon-plus" @click="onAdd"
          >积分申请</el-button
        >
      </div>
    </el-form>

    <el-table
      :data="tableData"
      style="width: 100%"
      @selection-change="onSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="schoolYear" label="学年" align="center"></el-table-column>
      <el-table-column prop="schoolTerm" label="学期" align="center">
        <template slot-scope="scope">{{
          scope.row.schoolTerm == 1 ? "上学期" : scope.row.schoolTerm == 2 ? "下学期" : "-"
        }}</template>
      </el-table-column>
      <el-table-column label="主题" align="center">
        <template slot-scope="scope">{{
          parseDeclareTitle(scope.row.title).theme || "-"
        }}</template>
      </el-table-column>
      <el-table-column prop="declareTitle" label="模块" align="center"></el-table-column>
      <el-table-column label="教研组" align="center" min-width="100">
        <template slot-scope="scope">{{ getRowGroupDisplay(scope.row) }}</template>
      </el-table-column>
      <el-table-column prop="teacherName" label="申请人" align="center"></el-table-column>
      <el-table-column prop="score" label="积分" align="center">
        <template slot-scope="scope">{{ scope.row.score || "-" }}</template>
      </el-table-column>
      <el-table-column fixed="right" align="center" label="操作" width="140">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="onView(scope.row)">查看</el-button>
          <el-button
            v-if="canEdit(scope.row)"
            type="text"
            size="small"
            @click="onEdit(scope.row)"
            >编辑</el-button
          >
          <el-popconfirm title="确定删除吗？" @confirm="onDel(scope.row)">
            <el-button
              v-if="canDelete(scope.row)"
              slot="reference"
              type="text"
              class="danger"
              size="small"
              >删除</el-button
            >
          </el-popconfirm>
        </template>
      </el-table-column>
      <pagination
        class="mb-md mr-md"
        slot="append"
        :pageObj="filterForm"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pagination>
    </el-table>

    <el-dialog
      :title="dialogAddEdit ? (editForm.id ? '编辑积分' : '积分申请') : '积分详情'"
      :visible.sync="dialogVisible"
      width="520px"
      @closed="onDialogClosed"
    >
      <template v-if="dialogAddEdit">
        <el-form ref="applyForm" :model="editForm" label-width="60px">
          <el-form-item label="模块">
            <el-radio-group v-model="editForm.infoCode">
              <el-radio
                v-for="item in moduleRadioOptions"
                :key="item.value"
                :label="item.value"
                >{{ item.label }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item label="教研组">
            <el-select
              v-model="editForm.groupCode"
              filterable
              placeholder="请选择教研组"
              style="width: 100%"
              :loading="editGroupLoading"
              @change="onEditGroupChange"
            >
              <el-option
                v-for="item in editGroupOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="主题">
            <el-input v-model="editForm.title" placeholder="请输入主题"></el-input>
          </el-form-item>
          <el-form-item v-if="editForm.infoCode === 'number_of_lectures'" label="节数">
            <el-input-number v-model="editForm.classNumber" :min="1" :max="100"></el-input-number>
          </el-form-item>
          <el-form-item v-if="editForm.infoCode === 'research_active'" label="评价">
            <el-input
              v-model="editForm.evalString"
              type="textarea"
              :rows="3"
              placeholder="请输入评价"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="editForm.infoCode === 'seminar'" label="级别">
            <el-radio-group v-model="editForm.level">
              <el-radio label="4">区级</el-radio>
              <el-radio label="3">镇级</el-radio>
              <el-radio label="2">校级</el-radio>
              <el-radio label="1">组级</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="editForm.infoCode === 'quality_analysis'" label="时段">
            <el-radio-group v-model="editForm.time">
              <el-radio label="1">期中</el-radio>
              <el-radio label="2">期末</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="上传">
            <uploader :file-list.sync="editForm.attaches" :limit="9"></uploader>
          </el-form-item>
        </el-form>
      </template>
      <el-descriptions v-else :column="2" border size="small">
        <el-descriptions-item label="学年">{{ viewRow.schoolYear || "-" }}</el-descriptions-item>
        <el-descriptions-item label="学期">{{
          viewRow.schoolTerm == 1 ? "上学期" : viewRow.schoolTerm == 2 ? "下学期" : "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="主题" :span="2">{{
          parseDeclareTitle(viewRow.title).theme || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="模块">{{ viewRow.declareTitle || "-" }}</el-descriptions-item>
        <el-descriptions-item label="教研组">{{
          getRowGroupDisplay(viewRow)
        }}</el-descriptions-item>
        <el-descriptions-item label="申请人">{{ viewRow.teacherName || "-" }}</el-descriptions-item>
        <el-descriptions-item
          v-if="viewRow.declareTitle === '教研活动'"
          label="评价"
          :span="2"
          >{{ parseDeclareTitle(viewRow.title).extra || "-" }}</el-descriptions-item
        >
        <el-descriptions-item
          v-if="viewRow.declareTitle === '教学研讨'"
          label="级别"
          :span="2"
          >{{ parseDeclareTitle(viewRow.title).extra || "-" }}</el-descriptions-item
        >
        <el-descriptions-item
          v-if="viewRow.declareTitle === '听课节数'"
          label="节数"
          :span="2"
          >{{ parseDeclareTitle(viewRow.title).extra || "-" }}</el-descriptions-item
        >
        <el-descriptions-item
          v-if="viewRow.declareTitle === '质量分析'"
          label="时段"
          :span="2"
          >{{ parseDeclareTitle(viewRow.title).extra || "-" }}</el-descriptions-item
        >
      </el-descriptions>
      <div slot="footer" class="dialog-footer text-center">
        <el-button @click="dialogVisible = false">{{
          dialogAddEdit ? "取 消" : "关 闭"
        }}</el-button>
        <el-button v-if="dialogAddEdit" type="primary" :loading="saving" @click="onSave"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import schoolYearSelector from "../../components/school/schoolYearSelector.vue";
import SchoolTermSelector from "../../components/school/schoolTermSelector.vue";
import Pagination from "../../components/Pagination.vue";
import Uploader from "../../components/school/uploader.vue";
import { mapGetters, mapState } from "vuex";
import { postData, postJson } from "../../http/fetch.js";

const MODULE_OPTIONS = [
  "备课",
  "命题",
  "质量分析",
  "教研活动",
  "教学研讨",
  "听课节数",
  "自主拓展",
  "教学培训",
];

const MODULE_RADIO_OPTIONS = [
  { label: "备课", value: "preparing_lessons" },
  { label: "命题", value: "proposition" },
  { label: "质量分析", value: "quality_analysis" },
  { label: "教研活动", value: "research_active" },
  { label: "教学研讨", value: "seminar" },
  { label: "听课节数", value: "number_of_lectures" },
  { label: "自主拓展", value: "self_expansion" },
  { label: "教学培训", value: "teaching_training" },
];

/** title 仅存主题与扩展信息：主题|&|扩展；教研组使用独立字段 groupCode/groupName */
function parseDeclareTitle(title) {
  const parts = (title || "").split("|&|");
  return {
    theme: parts[0] || "",
    extra: parts[1] === "-" ? "" : parts[1] || "",
  };
}

function createEmptyEditForm() {
  return {
    id: null,
    groupCode: "",
    groupName: "",
    infoCode: "preparing_lessons",
    title: "",
    classNumber: 1,
    evalString: "",
    level: "4",
    time: "2",
    attaches: [],
  };
}

export default {
  name: "scoreApply",
  components: {
    schoolYearSelector,
    SchoolTermSelector,
    Pagination,
    Uploader,
  },
  data() {
    return {
      pageLoading: false,
      loading: false,
      saving: false,
      downloadLoading: false,
      dialogVisible: false,
      dialogAddEdit: false,
      tableData: [],
      selection: [],
      teacherOptions: [],
      groupOptions: [],
      editGroupOptions: [],
      groupLoading: false,
      editGroupLoading: false,
      scoreTypeList: [],
      viewRow: {},
      editForm: createEmptyEditForm(),
      moduleOptions: MODULE_OPTIONS,
      moduleRadioOptions: MODULE_RADIO_OPTIONS,
      filterForm: {
        schoolYear: null,
        schoolTerm: null,
        moduleKeyword: "",
        teacherId: "",
        groupCode: "",
        size: 10,
        current: 1,
        total: 0,
        sizeList: [10, 15, 20, 25, 30],
      },
    };
  },
  computed: {
    ...mapGetters(["schoolCode", "schoolCodes", "operatorId"]),
    ...mapState(["userInfo", "isAdmin", "schoolYear", "schoolTerm"]),
  },
  async created() {
    this.filterForm.schoolYear = this.schoolYear;
    this.filterForm.schoolTerm = this.schoolTerm;
    await this.loadGroupOptions();
    this.applyDefaultGroupSelection(false);
    this.loadScoreTypeList();
    await this.loadTeacherOptions();
    this.getData();
  },
  methods: {
    parseDeclareTitle,
    getRowGroupDisplay(row) {
      if (!row) return "-";
      if (row.groupName) return row.groupName;
      if (row.groupCode) return this.getGroupLabel(row.groupCode) || row.groupCode;
      return "-";
    },
    getGroupLabel(groupCode) {
      if (!groupCode) return "";
      const item = this.groupOptions.find((g) => g.value === groupCode);
      return item ? item.label : "";
    },
    onEditGroupChange(code) {
      const item = this.editGroupOptions.find((g) => g.value === code);
      this.editForm.groupName = item ? item.label : "";
    },
    /** 列表筛选默认选中第一条教研组 */
    applyDefaultGroupSelection(refreshList) {
      if (!this.groupOptions.length) {
        this.filterForm.groupCode = "";
        return refreshList ? this.loadTeacherOptions().then(() => this.refresh()) : undefined;
      }
      const valid = this.groupOptions.some(
        (g) => g.value === this.filterForm.groupCode
      );
      if (!valid) {
        this.filterForm.groupCode = this.groupOptions[0].value;
      }
      return refreshList
        ? this.loadTeacherOptions().then(() => this.refresh())
        : undefined;
    },
    getDefaultEditGroup() {
      if (this.filterForm.groupCode) {
        const item = this.editGroupOptions.find(
          (g) => g.value === this.filterForm.groupCode
        );
        if (item) {
          return {
            groupCode: item.value,
            groupName: item.label,
          };
        }
      }
      if (this.editGroupOptions.length) {
        return {
          groupCode: this.editGroupOptions[0].value,
          groupName: this.editGroupOptions[0].label,
        };
      }
      return { groupCode: "", groupName: "" };
    },
    getEditGroupLabel(groupCode) {
      if (!groupCode) return "";
      const item = this.editGroupOptions.find((g) => g.value === groupCode);
      return item ? item.label : "";
    },
    refresh() {
      this.filterForm.current = 1;
      this.getData();
    },
    handleSizeChange(pageSize) {
      this.filterForm.current = 1;
      this.filterForm.size = pageSize;
      this.getData();
    },
    handleCurrentChange(curPage) {
      this.filterForm.current = curPage;
      this.getData();
    },
    async onYearTermChange() {
      this.filterForm.teacherId = "";
      await this.loadGroupOptions();
      await this.applyDefaultGroupSelection(true);
    },
    onGroupChange() {
      // 切换教研组时重置申请人，并批量重载该组教师列表
      this.filterForm.teacherId = "";
      this.loadTeacherOptions().then(() => this.refresh());
    },
    mapTeacherOptions(list, idKey, nameKey) {
      const mapped = (list || [])
        .map((item) => ({
          value: item[idKey] || item.userId || item.teacherId || "",
          label: item[nameKey] || item.userName || item.teacherName || "",
        }))
        .filter((item) => item.value);
      const seen = new Set();
      return mapped.filter((item) => {
        if (seen.has(item.value)) return false;
        seen.add(item.value);
        return true;
      });
    },
    mapGroupOptions(records) {
      return (records || [])
        .filter((item) => item.groupCode && item.groupName)
        .map((item) => ({
          value: item.groupCode,
          label: item.groupName,
        }));
    },
    async loadGroupOptions() {
      if (!this.userInfo) return;
      const schoolCode = this.schoolCode;
      if (!schoolCode) return;
      this.groupLoading = true;
      try {
        // 列表筛选用：管理员可见全校教研组
        const { records } = await postJson("/researchGroup/getResearchGroupInfoList", {
          operatorId: this.userInfo.userId,
          schoolCode,
          schoolCodes: this.schoolCodes,
          pageNum: 1,
          pageSize: -1,
          isAdmin: this.isAdmin ? 1 : 0,
        });
        this.groupOptions = this.mapGroupOptions(records);
      } catch (e) {
        this.groupOptions = [];
      } finally {
        this.groupLoading = false;
      }
    },
    async loadEditGroupOptions() {
      if (!this.userInfo) return;
      const schoolCode = this.schoolCode;
      if (!schoolCode) return;
      this.editGroupLoading = true;
      try {
        // 申请弹窗用：仅当前账号所在教研组
        const { records } = await postJson("/researchGroup/getResearchGroupInfoList", {
          operatorId: this.userInfo.userId,
          schoolCode,
          schoolCodes: this.schoolCodes,
          pageNum: 1,
          pageSize: -1,
          isAdmin: 0,
        });
        this.editGroupOptions = this.mapGroupOptions(records);
      } catch (e) {
        this.editGroupOptions = [];
      } finally {
        this.editGroupLoading = false;
      }
    },
    async loadTeacherOptions() {
      if (!this.filterForm.schoolYear || !this.filterForm.schoolTerm) {
        return;
      }

      // 选中教研组时一次批量拉取成员，避免循环单条查库
      if (this.filterForm.groupCode) {
        const groupTeachers = await postData(
          "/researchGroup/getResearchGroupTeacherList",
          {
            groupCode: this.filterForm.groupCode,
            schoolCode: this.schoolCode,
          }
        ).catch(() => []);
        // 管理员看全组；组长/组员均用组成员列表（组员非组长时不再与组长列表求交集）
        this.teacherOptions = this.mapTeacherOptions(groupTeachers, "userId", "userName");
        if (!this.isAdmin && !this.teacherOptions.length) {
          this.teacherOptions = [
            {
              value: this.userInfo.userId,
              label: this.userInfo.userName,
            },
          ];
        }
        return;
      }

      if (this.isAdmin) {
        const res = await postJson("/user/getTeacherInfoList", {
          schoolCodes: this.schoolCodes || [this.schoolCode],
        }).catch(() => null);
        this.teacherOptions = this.mapTeacherOptions(
          (res && res.records) || [],
          "userId",
          "userName"
        );
        return;
      }

      const leaderTeachers = await postData(
        "/researchGroup/getGroupTeachersByLeader",
        {
          leaderId: this.userInfo.userId,
          schoolCode: this.schoolCode,
          schoolYear: this.filterForm.schoolYear,
          schoolTerm: this.filterForm.schoolTerm,
        }
      ).catch(() => []);
      this.teacherOptions = this.mapTeacherOptions(
        leaderTeachers,
        "teacherId",
        "teacherName"
      );
    },
    buildUserIds() {
      if (this.filterForm.teacherId) {
        return [this.filterForm.teacherId];
      }
      if (this.teacherOptions.length) {
        return this.teacherOptions.map((item) => item.value);
      }
      return [this.userInfo.userId];
    },
    getData() {
      if (!this.filterForm.schoolYear || !this.filterForm.schoolTerm) {
        return;
      }
      this.loading = true;
      postJson("/declare/getScoreDeclareInfoList", {
        schoolYear: this.filterForm.schoolYear,
        schoolTerm: this.filterForm.schoolTerm,
        pageNum: this.filterForm.current,
        pageSize: this.filterForm.size,
        keyword: this.filterForm.moduleKeyword || undefined,
        schoolCode: this.schoolCode,
        schoolCodes: this.schoolCodes,
        groupCode: this.filterForm.groupCode || undefined,
        userIds: this.buildUserIds(),
      })
        .then((res) => {
          this.tableData = res.records || [];
          this.filterForm.size = res.size;
          this.filterForm.total = res.total;
          this.filterForm.current = res.current;
        })
        .catch(() => {
          this.tableData = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async loadScoreTypeList() {
      const res = await postJson("/teacherScoreInfo/getSysScoreInfoList", {
        pageNum: 1,
        pageSize: -1,
        schoolCodes: this.schoolCodes || [this.schoolCode],
      }).catch(() => null);
      this.scoreTypeList = (res && res.records) || [];
    },
    onSelectionChange(rows) {
      this.selection = rows;
    },
    canEdit(row) {
      return row.checkStatus != 1 && row.createBy == this.userInfo.userId;
    },
    canDelete(row) {
      return (
        (row.checkStatus != 1 && row.createBy == this.userInfo.userId) || this.isAdmin
      );
    },
    async onAdd() {
      await this.loadEditGroupOptions();
      const group = this.getDefaultEditGroup();
      this.editForm = {
        ...createEmptyEditForm(),
        groupCode: group.groupCode,
        groupName: group.groupName,
      };
      this.dialogAddEdit = true;
      this.dialogVisible = true;
    },
    onView(row) {
      this.viewRow = row;
      this.dialogAddEdit = false;
      this.dialogVisible = true;
    },
    async onEdit(row) {
      await this.loadEditGroupOptions();
      const group = row.groupCode
        ? {
            groupCode: row.groupCode,
            groupName: row.groupName || this.getEditGroupLabel(row.groupCode),
          }
        : this.getDefaultEditGroup();
      this.editForm = {
        ...createEmptyEditForm(),
        id: row.id,
        groupCode: group.groupCode,
        groupName: group.groupName,
      };
      const parsed = parseDeclareTitle(row.title);
      this.editForm.title = parsed.theme || "";
      this.editForm.infoCode = this.getInfoCodeByDeclareTitle(row.declareTitle);
      const extra = parsed.extra || "";
      if (row.declareTitle === "听课节数") {
        this.editForm.classNumber = parseInt(extra, 10) || 1;
      } else if (row.declareTitle === "教研活动") {
        this.editForm.evalString = extra;
      } else if (row.declareTitle === "教学研讨") {
        this.editForm.level = this.getLevelCode(extra);
      } else if (row.declareTitle === "质量分析") {
        this.editForm.time = extra === "期中" ? "1" : "2";
      }
      this.dialogAddEdit = true;
      this.dialogVisible = true;
    },
    getInfoCodeByDeclareTitle(title) {
      const map = {
        听课节数: "number_of_lectures",
        教研活动: "research_active",
        教学研讨: "seminar",
        质量分析: "quality_analysis",
        备课: "preparing_lessons",
        命题: "proposition",
        教学培训: "teaching_training",
        自主拓展: "self_expansion",
      };
      return map[title] || "preparing_lessons";
    },
    getLevelCode(label) {
      const map = { 区级: "4", 镇级: "3", 校级: "2", 组级: "1" };
      return map[label] || "4";
    },
    buildSubmitPayload() {
      let infoCode = this.editForm.infoCode;
      let title = this.editForm.title;
      if (infoCode === "number_of_lectures") {
        infoCode =
          (this.editForm.classNumber || 0) >= 8
            ? "number_of_lectures1"
            : "number_of_lectures2";
        title = `${title}|&|${this.editForm.classNumber}节`;
      } else if (infoCode === "seminar") {
        const levelMap = { 4: "seminar4", 3: "seminar3", 2: "seminar2", 1: "seminar1" };
        const labelMap = { 4: "区级", 3: "镇级", 2: "校级", 1: "组级" };
        infoCode = levelMap[this.editForm.level] || "seminar4";
        title = `${title}|&|${labelMap[this.editForm.level] || "区级"}`;
      } else if (infoCode === "quality_analysis") {
        infoCode = this.editForm.time === "1" ? "quality_analysis1" : "quality_analysis2";
        title = `${title}|&|${this.editForm.time === "1" ? "期中" : "期末"}`;
      } else if (infoCode === "research_active") {
        title = `${title}|&|${this.editForm.evalString || ""}`;
      }

      const declareTitleMap = {
        number_of_lectures1: "听课节数",
        number_of_lectures2: "听课节数",
        research_active: "教研活动",
        seminar1: "教学研讨",
        seminar2: "教学研讨",
        seminar3: "教学研讨",
        seminar4: "教学研讨",
        quality_analysis1: "质量分析",
        quality_analysis2: "质量分析",
        preparing_lessons: "备课",
        proposition: "命题",
        teaching_training: "教学培训",
        self_expansion: "自主拓展",
      };

      const scoreItem = this.scoreTypeList.find((item) => item.parentCode === infoCode);
      return {
        id: this.editForm.id,
        operatorId: this.operatorId,
        schoolCode: this.schoolCode,
        schoolYear: this.filterForm.schoolYear,
        schoolTerm: this.filterForm.schoolTerm,
        teacherName: this.userInfo.userName,
        teacherId: this.userInfo.userId,
        title,
        groupCode: this.editForm.groupCode,
        groupName: this.editForm.groupName,
        declareTitle: declareTitleMap[infoCode] || "其它",
        declareDate: new Date().toISOString().slice(0, 10),
        infoCode: (scoreItem && scoreItem.infoCode) || "",
        score: (scoreItem && scoreItem.score) || 0,
        checkStatus: 0,
        attaches: (this.editForm.attaches || []).map((u) => ({
          name: u.attachName || u.name,
          size: u.attachSize || u.size,
          type: u.attachType || u.type,
          url: u.attachUrl || u.url,
        })),
      };
    },
    onSave() {
      if (!this.editForm.groupCode) {
        this.$message.warning("请选择教研组");
        return;
      }
      if (!this.editForm.title) {
        this.$message.warning("请输入主题");
        return;
      }
      this.saving = true;
      postJson("/declare/saveOrUpdateScoreDeclareInfo", this.buildSubmitPayload())
        .then(() => {
          this.$message.success(this.editForm.id ? "更新成功" : "保存成功");
          this.dialogVisible = false;
          this.refresh();
        })
        .finally(() => {
          this.saving = false;
        });
    },
    onDel(row) {
      postJson("/declare/deleteScoreDeclareInfo", {
        id: row.id,
        operatorId: this.operatorId,
      }).then(() => {
        this.$message.success("删除成功");
        this.getData();
      });
    },
    onBatchDownload() {
      const ids = this.selection.map((item) => item.id);
      if (!ids.length) return;
      this.downloadLoading = true;
      this.$axios
        .post(
          "/declare/downloadFile",
          { ids },
          {
            responseType: "blob",
            headers: { "Content-Type": "application/json" },
          }
        )
        .then((res) => {
          const disposition = res.headers["content-disposition"] || "";
          let fileName = "积分申请文件.xlsx";
          const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (match && match[1]) {
            fileName = decodeURIComponent(match[1].replace(/['"]/g, ""));
          }
          const url = URL.createObjectURL(res.data);
          const a = document.createElement("a");
          a.href = url;
          a.download = fileName;
          a.click();
          URL.revokeObjectURL(url);
          return postJson("/declare/checkScoreDeclareInfo", {
            ids,
            checkStatus: 1,
          });
        })
        .then(() => {
          this.getData();
        })
        .finally(() => {
          this.downloadLoading = false;
        });
    },
    onDialogClosed() {
      this.editForm = createEmptyEditForm();
      this.viewRow = {};
    },
  },
};
</script>
